import { useState, useEffect } from "react";
import { Drawer } from "@made-people/blueprint-drawer";
import { overlayEventEmitter } from "@made-people/blueprint-overlay";
import { Cross } from "../../../assets/icons/Cross";
import { useWashingInstruction } from "../../../hooks/use-washing-instruction";
import { useTranslate } from "@made-people/grease-translations";

const OVERLAY_ID = "washing-instruction";

export const openWashingInstruction = () => {
  overlayEventEmitter.emit("open", { overlayId: OVERLAY_ID });
};

const useIsDesktop = () => {
  const [isDesktop, setIsDesktop] = useState(false);

  useEffect(() => {
    const mq = window.matchMedia("(min-width: 1024px)");
    setIsDesktop(mq.matches);
    const handler = (e: MediaQueryListEvent) => setIsDesktop(e.matches);
    mq.addEventListener("change", handler);
    return () => mq.removeEventListener("change", handler);
  }, []);

  return isDesktop;
};

export const WashingInstructionDrawer = () => {
  const instructions = useWashingInstruction();
  const isDesktop = useIsDesktop();
  const translate = useTranslate();

  if (!instructions) return null;

  return (
    <Drawer
      customOverlayId={OVERLAY_ID}
      direction={isDesktop ? "right" : "bottom"}
      hasHandle={!isDesktop}
      header={{
        headingSettings: {
          variants: {
            headingSize: "md",
          },
          heading: instructions.heading,
        },
        closeIcon: <Cross className="w-3 h-3" />,
      }}
    >
      <Drawer.Trigger className="underline underline-offset-2">
        {translate("Washing_Instructions_Trigger")}
      </Drawer.Trigger>
      <Drawer.Content
        contentSettings={{
          className:
            "lg:h-full lg:w-[480px] max-h-[85dvh] lg:max-h-none lg:max-w-[480px]",
        }}
      >
        <ol className="flex flex-col gap-6 pt-4 pb-10 overflow-y-scroll">
          {instructions.instructions.map(({ text }, index) => {
            if (!text) return null;
            return (
              <li key={index} className="flex gap-4 items-start">
                <span className="flex-shrink-0 w-8 h-8 rounded-full bg-neutral-900 text-white flex items-center justify-center text-body-sm">
                  {index + 1}
                </span>
                <p className="text-body-md">{text}</p>
              </li>
            );
          })}
        </ol>
      </Drawer.Content>
    </Drawer>
  );
};
